import { render, staticRenderFns } from "./ArticuloHorizontalCard.vue?vue&type=template&id=eef82a28&scoped=true&"
import script from "./ArticuloHorizontalCard.vue?vue&type=script&lang=js&"
export * from "./ArticuloHorizontalCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticuloHorizontalCard.vue?vue&type=style&index=0&id=eef82a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef82a28",
  null
  
)

export default component.exports